import React, { FC, useState } from 'react';
import { ArrowDropDown } from '@mui/icons-material';
import { Button, FormControlLabel, Menu, MenuItem, RadioGroup, Checkbox } from '@mui/material';

export interface CheckboxOption {
  label: string;
  value: string;
}

interface MenuWithCheckboxesProps {
  label: string;
  options: CheckboxOption[];
  selectedOptions: string[];
  onSelect: (option: CheckboxOption) => void;
  className?: string;
}

const MenuWithCheckboxes: FC<MenuWithCheckboxesProps> = ({ label, options, selectedOptions, onSelect, className }) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  return (
    <div className={`${className ? className : ''}`}>
      <Button
        sx={{ color: 'black' }}
        aria-controls="menu"
        aria-haspopup
        endIcon={<ArrowDropDown />}
        onClick={handleClick}
        className="h-10 flex max-w-[350px] min-w-[200px] px-[15px] py-[7px] font-montserrat text-[#575757] text-base whitespace-nowrap justify-between text-left bg-white shadow-[2px_2px_6px_rgba(0,0,0,0.16)] hover:border-none hover:cursor-pointer max-[1038px]:max-w-none max-[1038px]:min-w-auto max-[1038px]:w-full max-[1038px]:mx-[6px_12px_6px_0] max-[500px]:text-sm"
      >
        {label}
      </Button>
      <Menu anchorEl={anchorElement} open={!!anchorElement} onClose={handleClose}>
        <RadioGroup>
          {options.map((option: any, index) => (
            <MenuItem key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOptions.includes(option.value)}
                    onChange={() => onSelect(option)}
                    color="primary"
                  />
                }
                label={option.label}
                className="text-[#575757]"
              />
            </MenuItem>
          ))}
        </RadioGroup>
      </Menu>
    </div>
  );
};

export default MenuWithCheckboxes;
